var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLpMain = function SvgLpMain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    "data-bbox": "1.237 1.237 1029.526 588.528",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1032 591",
    height: 591,
    width: 1032,
    "data-type": "ugc",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3,
    stroke: "#fff",
    fill: "#CFEAF2",
    d: "M1024.5 7.5v575H7.5V7.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1001 82v426c0 27.614-22.386 50-50 50H81c-27.614 0-50-22.386-50-50V82c0-27.614 22.386-50 50-50h870c27.614 0 50 22.386 50 50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.474,
    stroke: "#fff",
    fill: "#fff",
    d: "M1030.763 584a5.763 5.763 0 1 1-11.526 0 5.763 5.763 0 0 1 11.526 0zM12.763 584a5.763 5.763 0 1 1-11.526 0 5.763 5.763 0 0 1 11.526 0zM1030.763 7a5.763 5.763 0 1 1-11.526 0 5.763 5.763 0 0 1 11.526 0zM12.763 8A5.763 5.763 0 1 1 1.237 8a5.763 5.763 0 0 1 11.526 0z"
  })));
};
export default SvgLpMain;